<div class="policy-billing-upload">
    <form [formGroup]="uploadDocForm" (ngSubmit)="uploadDocForm?.valid && uploadDocuments()" class="ng-select-main" [ngClass]="{'upload-doc-acmic':isAcmic}">
        <div class="upload-files-title">{{ 'UPLOAD_DOCS' | translate}}</div>
        <div class="upload-files-sub-title">Choose policy</div>
        <div class="choose-pol-sub-txt" [ngClass]="{'lh-normal margin-bottom mb4':!isAcmic}">All documents will be uploaded to the selected policy</div>
        <div class="upload-pol-sel" [ngClass]="{'material arrow-wrap':isAcmic}">
            <ng-select 
                [items]="policyMap" 
                bindLabel="name" 
                [autofocus]="false" 
                bindValue="name" 
                [searchable]="false" 
                [multiple]="false"
                [clearable]="false" 
                [markFirst]="false" 
                placeholder="Select" 
                fixedPlaceholder="true"
                [formControlName]="'selectedPolicy'"
                (change)="onPOlicySelect()"> 
                </ng-select>
        </div>
        <div class="upload-files-sub-title">Add policy and billing documents</div>
        <ng-container *ngIf="files?.length >= 10; else choseFileToUpload;">
            <div>
                <div class="warn-notice">
                    <div class="warn-img">
                        <img src="assets/img/images/icon-warning-attention.svg" />
                    </div>
                    <div class="warn-content" [ngClass]="{'dm-sans-medium':!isAcmic}">
                        {{'You’ve reached the limit of files you can upload'}}
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #choseFileToUpload>
            <div>
                <div class="choose-pol-sub-txt">Choose the files you need to upload</div>
                <div class="choose-file" [ngClass]="{'back-col-F2F2F2':isAcmic}">
                    <div><img alt="upload file icon" src="assets/img/images/upload-icon.svg"></div>
                    <div class="drag-drop-txt lh-normal">
                        <label for="customFile1" class="choose-file-input">Choose file</label>
                        <input type="file" multiple class="form-control d-none" id="customFile1" #myInputFile
                            (change)="onChange($event)" (click)="myInputFile.value = null" />
                        or drag and drop here
                    </div>
                    <div class="grey-color max-size-text">Max. 10 files</div>
                    <div class="grey-color max-size-text fs-12">JPG, PDF, GIF & PNG (Max. size 50MB per file)</div>
                </div>
            </div>
        </ng-template>
        <ng-container *ngIf="files?.length">
            <div class="upload-files-sub-title">{{'Document data' | translate }}</div>
            <div class="choose-pol-sub-txt">{{'Confirm document name and remember to choose a document type'}}</div>
            <div class="upload-documents-sec">
                <table class="table table-striped info-table hide-in-mobile" [ngClass]="{'table-acmic table-striped-acmic':isAcmic,'table-ma col-2d373d':!isAcmic}">
                    <tbody>
                        <tr class="">
                            <th class="upload-w-50">
                
                            </th>
                            <th class="upload-w-330 document-name" [ngClass]="{'dm-sans-medium':!isAcmic}">
                                <span class="fw-500"> {{ 'Document name' | translate }}</span>
                            </th>
                            <th class="upload-w-330 document-type-height padding-left pl16" [ngClass]="{'dm-sans-medium':!isAcmic}">
                                <span class="fw-500"> {{ 'Document type' | translate }}</span>
                            </th>
                            <th class="upload-w-50">
                
                            </th>
                            <th class="upload-w-50">
                
                            </th>
                        </tr>
                        <ng-container *ngFor="let file of files; index as i">
                            <tr>
                                <td class="upload-w-50 index-{{i}} upload-doc-number" [ngClass]="{'fw-500':isAcmic}">
                                    {{ i+1 }}
                                </td>
                                <ng-container *ngIf="!file?.saved; else unavedDoc">
                        
                                    <td class="upload-w-330">
                                        <div class="input-field mapfre">
                                            <input type="text" formControlName="documentName{{i}}"  name="documentName{{i}}" [ngClass]="{'document-name-input':isAcmic}">
                                        </div>
                        
                                    </td>
                                    <td class="upload-w-330 padding-left pl16">
                                        <div class="upload-w-298" [ngClass]="{'ng-custom-select-acmic  pb-0 ':isAcmic}">
                                            <!-- <select class="custom-select-font custom-select custom-select-down-arrow" 
                                                name="select-document-type" id="select-doc-type"
                                                formControlName="documentType{{i}}"
                                                (change)="onDoumentSelect(i, $event)"
                                                placeholder="Select one"
                                                >
                                                <option disabled value="">Select one</option>
                                                <option *ngFor="let polDocType of documentTypes" [value]="polDocType?.type">
                                                    {{ polDocType?.type | titlecase }}
                                                </option>
                                            </select> -->
                                            <ng-select 
                                            [items]="documentTypes" 
                                            bindLabel="type" 
                                            [autofocus]="false" 
                                            bindValue="type" 
                                            [searchable]="false" 
                                            [multiple]="false"
                                            [clearable]="false" 
                                            [markFirst]="false" 
                                            placeholder="Select one" 
                                            fixedPlaceholder="true"
                                            formControlName="documentType{{i}}"
                                            (change)="onDoumentSelect(i,$event)"
                                            (open)="onDropdownOpen()"
                                            (close)="onDropdownClose()"
                                            > 
                                            </ng-select>
                                        </div>
                                    </td>
                                    <td class="upload-w-50 upload-save-btn-pd">
                                        <ng-container *ngIf="file?.documentType?.length; else noLink">
                                            <span class="save-action-color underlineBQ cursor-pointer" (click)="toggleEditAndSave(true, i, 'save')">
                                                Save
                                            </span>
                                        </ng-container>
                                        <ng-template #noLink>
                                            <div class="disable-save">
                                                Save
                                            </div>
                                        </ng-template>
                                        
                                    </td>
                                </ng-container>
                                <ng-template #unavedDoc>
                                    <td class="upload-w-330 fs-16 fw-400" [ngClass]="{'fs-14':isAcmic}">
                                        {{file?.documentName}}
                                    </td>
                                    <td class="upload-w-298 padding-left pl16 fs-16 fw-400" [ngClass]="{'fs-14':isAcmic}">
                                        {{file?.documentType}}
                                    </td>
                                    
                                    <td class="upload-w-50" [ngClass]="{'upload-save-btn-pd':!file?.isEdit}">
                                        <ng-container *ngIf="!file?.isEdit; else editIcon">
                                            <span class="save-action-color underlineBQ cursor-pointer" (click)="toggleEditAndSave(true, i, 'save')">
                                                Save
                                            </span>
                                        </ng-container>
                                        <ng-template #editIcon>
                                        <span class="cursor-pointer" (click)="toggleEditAndSave(false, i, 'edit')">
                                            <img [src]="editIconPath" alt="edit icon" />
                                        </span>
                                        </ng-template>
                                    </td>
                                </ng-template>
                        
                                <td class="upload-w-50 delete-icon-pd">
                                    <!-- <span  > -->
                                        <img [src]="deleteIconPath" class="cursor-pointer" (click)="deleteDocumentFields(i)" alt="delete icon" />
                        
                                    <!-- </span> -->
                                </td>
                        </ng-container>
                        
                    </tbody>
                </table>
                <div class="hide-in-desktop upload-files-in-mobile" [ngClass]="{'doctype-acmic' : isAcmic}">
                    <ng-container *ngFor="let file of files; index as i">
                        <div class="responsive-upload-card">
                            <div class="frame-327">
                                <div class="frame-number pl-0" [ngClass]="{'fs-14': isAcmic}">{{ i+1 }}</div>
                                <!-- <ng-container *ngIf="!file?.saved; else unavedMobileinputs"> -->
                                <div class="frame-feild-group">
                                    <div class="document-feild">
                                        <div class="document-feild-type" [ngClass]="{'document-feild-typeAcmic':isAcmic}">Document name</div>
                                        <ng-container *ngIf="file?.saved; else unSavedDocName">
                                            <div class="fs-16" [ngClass]="{'document-feild-content-typeAcmic':isAcmic}">{{file?.documentName}}</div>
                                        </ng-container>
                                        <ng-template #unSavedDocName>
                                            <div class="input-field mapfre">
                                                <input type="text" name="documentName{{i}}" formControlName="documentName{{i}}"
                                                    >
                                            </div>
                                        </ng-template>
                                        
                                    </div>
                                    <div class="document-feild" [ngClass]="{'hide-label':isAcmic}">
                                        <div class="document-feild-type" [ngClass]="{'document-feild-typeAcmic':isAcmic}">Document Type</div>
                                        <ng-container *ngIf="file?.saved; else unSavedDocType">
                                            <div class="fs-16" [ngClass]="{'document-feild-content-typeAcmic':isAcmic}">{{file?.documentType}}</div>
                                        </ng-container>
                                        <ng-template #unSavedDocType>
                                        <!-- <select class="custom-select-font custom-select custom-select-down-arrow" name="select-document-type"
                                                id="select-doc-type" formControlName="documentType{{i}}"
                                                (change)="onDoumentSelect(i, $event)" placeholder="Select one">
                                                <option disabled value="">Select one</option>
                                                <option *ngFor="let polDocType of documentTypes">
                                                    {{ polDocType?.type | titlecase }}
                                                </option>
                                        </select> -->
                                        <ng-select 
                                        [items]="documentTypes" 
                                        bindLabel="type" 
                                        [autofocus]="false" 
                                        bindValue="type" 
                                        [searchable]="false" 
                                        [multiple]="false"
                                        [clearable]="false" 
                                        [markFirst]="false" 
                                        placeholder="Select one" 
                                        fixedPlaceholder="true"
                                        formControlName="documentType{{i}}"
                                        (change)="onDoumentSelect(i,$event)"> 
                                        </ng-select>
                                        </ng-template>
                                    </div>
                                </div>
                                <!-- </ng-container>
                                <ng-template #unavedMobileinputs>

                                </ng-template> -->
                            </div>
                            <div class="upload-actions">
                                <div class="upload-save">
                                    <ng-container *ngIf="!file?.saved; else unavedMobileDoc">
                                        <ng-container *ngIf="file?.documentType?.length; else noLinkMobile">
                                            <span class="save-action-color underlineBQ cursor-pointer" (click)="toggleEditAndSave(true, i, 'save')">
                                                Save
                                            </span>
                                        </ng-container>
                                        <ng-template #noLinkMobile>
                                            <span class="disable-save">
                                                Save
                                            </span>
                                        </ng-template>
                                        
                                    </ng-container>
                                    <ng-template #unavedMobileDoc>
                                        <ng-container *ngIf="!file?.isEdit; else editIcon">
                                            <span class="save-action-color underlineBQ cursor-pointer" (click)="toggleEditAndSave(true, i, 'save')">
                                                Save
                                            </span>
                                        </ng-container>
                                        <ng-template #editIcon>
                                        <span class="cursor-pointer" (click)="toggleEditAndSave(false, i, 'edit')">
                                            <img [src]="editIconPath" alt="edit icon" />
                                        </span>
                                        </ng-template>
                                    </ng-template>
                                </div>
                                <div class="upload-delete upload-delete-icon-pd">
                                    <span class="cursor-pointer" (click)="deleteDocumentFields(i)">
                                        <img [src]="deleteIconPath" alt="delete icon" />
                    
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                </div>
            </div>
        </ng-container>
        <div class="upload-file-actions">
            <mapfre-button 
                [ngClass]="{'custom_loader': loading}" 
                [additionalClasses]="'basic primary large-btn mx-auto upload-btn'"
                [disabledValue]="uploadDocForm?.valid && files?.length > 0 && files?.length <= 10 && listOfFiles().length === files?.length" [inputType]="'submit'"
                [translateValue]="'Upload' | translate">
            </mapfre-button>
            <mapfre-button 
                (click)="goBack()"
                [additionalClasses]="'ghost secondary large-btn mx-auto upload-cancel-btn'"
            >{{'Cancel' | translate}}
            </mapfre-button>
        </div>
    </form>
</div>
<app-invalid-file-type-modal 
(closeInvalidFileTypeModal)="closeInvalidFileTypeModal()"
*ngIf="invalidFileType?.length"></app-invalid-file-type-modal>
<app-success-modal-for-upload-doc 
    [policyId]="policyNumber"
    (closeSuccessModal)="closeShowSuccessModal()" 
    *ngIf="showSuccessModal">
</app-success-modal-for-upload-doc>
<app-in-progress-modal 
    [policyId]="policyNumber"
    (closeSuccessModal)="closeShowInProgressModal()" 
    *ngIf="showInProgressModal">
</app-in-progress-modal>
<mapfre-modal
  *ngIf="showFailureModal"
      [modalOptions]="failureModalOptions"
      [hideModal]="hideModal"
      (hideModalOutput)="resetHideModal()"
    (click)="hideOnClick($event)"
      
    >
    <app-failure-modal-for-upload-doc
        (isTryAgain)="tryAgain($event)">
    </app-failure-modal-for-upload-doc>
</mapfre-modal>